import dayjs, { Dayjs, UnitType } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';

dayjs.extend(customParseFormat);
dayjs.extend(localeData);

export default dayjs;
export { Dayjs, UnitType };
